module.exports = __webpack_public_path__ + "4da3706de5179bea3d3324cbc74712df.png";